import React from 'react';
import { Table } from 'semantic-ui-react';
import { states } from '@/constants/lifecycle';
import CompactTableHeader from '@/components/table/CompactTableHeader';
import TableErrorRow from '@/components/table/TableErrorRow';

const UsergroupUsersTableHeader = ({
  children,
  error,
  onErrorDismiss,
  readStatus,
}) => (
  <Table.Header className="aridhia-usergroup-users-table-header" fullWidth>
    {readStatus === states.PENDING && (
      <CompactTableHeader className="aridhia-usergroup-users-header" isLoading numberOfColumns={3} />
    )}
    <TableErrorRow error={error} numberOfColumns={3} onErrorDismiss={onErrorDismiss} />
    {children}
  </Table.Header>
);

export default UsergroupUsersTableHeader;
